import { call, put } from "redux-saga/effects";
import { authApi } from "@services/api";
import { forgotPasswordActions } from "../slices";
import { showFailureToast, showSuccessToast } from "@helpers";
import { has } from "lodash";

function* forgotPasswordWorker({ payload }) {
  try {
    yield put(forgotPasswordActions.pending());
    const response = yield call(authApi.forgotPassword, payload);
    yield put(forgotPasswordActions.success(response));
    // TODO: handle callback | onSuccess
    showSuccessToast("Verification code has been sent to your email.");
    if (has(payload, "onSuccess")) {
      payload.onSuccess();
    }
  } catch (error) {
    yield put(forgotPasswordActions.failure(error));
    // TODO: handle callback | onFailure
    showFailureToast("Something went wrong, we can't connect to your email.");
  }
}

export { forgotPasswordWorker };
